var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 5.60156L5.10156 1.125C5.3125 0.890625 5.66406 0.890625 5.89844 1.125C6.10938 1.33594 6.10938 1.6875 5.89844 1.89844L1.77344 6L5.875 10.125C6.10938 10.3359 6.10938 10.6875 5.875 10.8984C5.66406 11.1328 5.3125 11.1328 5.10156 10.8984L0.601562 6.39844C0.367188 6.1875 0.367188 5.83594 0.601562 5.60156Z",
    fill: "#0076A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.984477acf1f9b3af7c5a7e39fc79f6af.svg";
export { ForwardRef as ReactComponent };